import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AppDispatch, GetState, RootState } from '@SonarCX/store'

import { getWidgetArticle } from '@SonarCX/lib/api'

type WidgetArticleState = {
  loading: string[]
  loaded: string[]
  articles: Record<string, any>
}

const initialState: WidgetArticleState = {
  loading: [],
  loaded: [],
  articles: {}
}

const widgetArticleSlice = createSlice({
  name: 'widgetArticle',
  initialState,
  reducers: {
    startLoad: (state: WidgetArticleState, action: PayloadAction<string>) => {
      state.loading.push(action.payload)
    },

    finishLoad: (
      state: WidgetArticleState,
      action: PayloadAction<{ id: string; val: any }>
    ) => {
      state.loading = state.loading.filter(id => id !== action.payload.id)
      state.loaded.push(action.payload.id)
      state.articles[action.payload.id] = action.payload.val
    }
  }
})

const { startLoad, finishLoad } = widgetArticleSlice.actions

export const loadWidgetArticle = (id: string) => {
  return async (dispatch: AppDispatch, getState: GetState) => {
    dispatch(startLoad(id))
    const article = await getWidgetArticle(id)
    dispatch(finishLoad({ id, val: article }))
  }
}

export const selectWidgetArticle = (state: RootState) => state.widgetArticle

export default widgetArticleSlice.reducer
